import React from 'react';
import PropTypes from 'prop-types';

const LocationNameDisplayComponent = ({ name, url, ...extendedProps }) => (
  <h3 className="location-name" {...extendedProps}>
    <a href={url}>{name}</a>
  </h3>
);

LocationNameDisplayComponent.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default LocationNameDisplayComponent;
